import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogFooter,
    DialogHeader,
    DialogDescription,
} from 'src/domains/common/components/dialog/dialog';
import { Button } from 'src/domains/common/components/button/button';
import { observer } from 'mobx-react-lite';
import { DIALOG_ROOT } from 'src/domains/casino/utils/test-variables';
import { cn } from 'src/domains/common/components/utils';

interface DialogGenericPropsType {
    cancel_label?: string;
    confirm_label?: string;
    delete_label?: string;
    hasOverlay?: boolean;
    isLoading?: boolean;
    message?: JSX.Element;
    onCancel?: () => void;
    onConfirm?: () => void;
    onDelete?: () => void;
    title?: string;
    titleClassName?: string;
    dialogClassName?: string;
}

export const DialogGeneric = observer(
    ({
        cancel_label,
        confirm_label,
        delete_label,
        hasOverlay = true,
        isLoading = false,
        message,
        onCancel,
        onConfirm,
        onDelete,
        title,
        titleClassName,
        dialogClassName,
    }: DialogGenericPropsType): JSX.Element => {
        return (
            <Dialog
                onClickOutside={onCancel}
                hasOverlay={hasOverlay}
                className={cn('w-[462px]', dialogClassName)}
                dataTest={DIALOG_ROOT}
            >
                <DialogHeader>
                    <DialogTitle
                        data-test='dialog-title'
                        className={titleClassName}
                    >
                        {title}
                    </DialogTitle>
                    <DialogDescription data-test='dialog-description'>{message}</DialogDescription>
                </DialogHeader>

                <DialogFooter data-test='dialog-footer'>
                    {cancel_label === undefined ? null : (
                        <Button
                            variant='outline'
                            onClick={onCancel}
                            data-test='dialog-cancel-button'
                        >
                            {cancel_label}
                        </Button>
                    )}

                    {confirm_label === undefined ? null : (
                        <Button
                            disabled={isLoading}
                            isLoading={isLoading}
                            onClick={onConfirm}
                            variant='primary'
                            data-test='dialog-confirm-button'
                        >
                            {confirm_label}
                        </Button>
                    )}

                    {delete_label === undefined ? null : (
                        <Button
                            disabled={isLoading}
                            isLoading={isLoading}
                            onClick={onDelete}
                            variant='destructive'
                            data-test='dialog-delete-button'
                        >
                            {delete_label}
                        </Button>
                    )}
                </DialogFooter>
            </Dialog>
        );
    }
);
